import request from '@/utils/request'

export function getChildren () {
  return request({
    url: '/children/',
    method: 'get'
  })
}

export function addChild (data) {
  return request({
    url: '/children/',
    method: 'post',
    data
  })
}

export function getChild (id) {
  return request({
    url: '/children/' + id + '/',
    method: 'get'
  })
}

export function updateChild (data) {
  const id = data.id
  return request({
    url: '/children/' + id + '/',
    method: 'put',
    data
  })
}

export function delChild (id) {
  return request({
    url: '/children/' + id + '/',
    method: 'delete'
  })
}
